/**
 * Layout styled components
 */

import styled from "styled-components/macro";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
  Box,
  Paper,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";

export const Divider = styled(MuiDivider)(spacing);
export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

export const FiltersContainer = styled(Box)`
  margin-bottom: ${(props) => props.theme.spacing(4)}px;
`;

export const FilterCard = styled(Paper)`
  padding: ${(props) => props.theme.spacing(2)}px;
  height: 100%;
`;

export const FilterHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing(1)}px;
  padding-bottom: ${(props) => props.theme.spacing(1)}px;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;

export const FilterLabel = styled(Typography)`
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${(props) => props.theme.palette.text.secondary};
`;

export const FilterActions = styled(Box)`
  display: flex;
  gap: 4px;
`;

export const TableSection = styled(Paper)`
  margin-bottom: ${(props) => props.theme.spacing(3)}px;
  padding: ${(props) => props.theme.spacing(2)}px;
  border: 1px solid ${(props) => props.theme.palette.divider};
`;

export const TableTitle = styled(Typography)`
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  &:hover {
    opacity: 0.8;
  }
`;

export const CollapseIcon = styled(Box)`
  display: flex;
  align-items: center;
  margin-right: ${(props) => props.theme.spacing(1)}px;
`;

export const TableControls = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing(2)}px;
  flex-wrap: wrap;
  gap: ${(props) => props.theme.spacing(1)}px;
`;

export const NoDataMessage = styled(Box)`
  padding: ${(props) => props.theme.spacing(4)}px;
  text-align: center;
  color: ${(props) => props.theme.palette.text.secondary};
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(2)}px;
`;

export const ExpandIcon = styled(Box)`
  display: inline-flex;
  align-items: center;
  margin-right: 4px;
  vertical-align: middle;
`;
